<template>

  <el-alert
    v-if="shopCtx.selfScope"
    class="mb-3!"
    :title="`商品统计已按${shopCtx.tradeScopeHint || '本店'}过滤（仅本店 SPU）`"
    type="info"
    show-icon
    :closable="false"
  />
  <!-- 商品概览 -->
  <ProductSummary />
  <!-- 商品排行 -->
  <ProductRank class="mt-16px" />
</template>
<script lang="ts" setup>
import ProductSummary from './components/ProductSummary.vue'
import ProductRank from './components/ProductRank.vue'
import { useMallSelfShopContext } from '@/hooks/web/useMallSelfShopContext'

/** 商品统计 */
defineOptions({ name: 'ProductStatistics' })

const { context: shopCtx } = useMallSelfShopContext()
</script>
<style lang="scss" scoped></style>

